import React, { useState, useEffect, useRef } from 'react';

import './index.scss';

const Avatar = ({ name, url, bg, color, noRadius }) => {
  const [avatarName, setAvatarName] = useState(null);
  const [sizes, setSizes] = useState({ font: 16, line: 16 });
  const [styles, setStyles] = useState({});
  const myAvatar = useRef();

  // stiller set edilir.
  useEffect(() => {
    const obj = {};
    if (bg) {
      obj.backgroundColor = bg;
    }
    if (color) {
      obj.color = color;
    }
    if (noRadius) {
      obj.borderRadius = '0';
    }
    setStyles(obj);
  }, [bg, color, noRadius]);

  // TODO: ref ile genişliğini al ve ona göre font-size ver!!
  useEffect(() => {
    if (myAvatar?.current) {
      const width = myAvatar.current.clientWidth;
      const calc = width / avatarName?.length;
      setSizes({ font: calc });
    }
  }, [avatarName]);

  // baş harflerini alıyoruz
  useEffect(() => {
    if (name) {
      const split = name.split(' ');
      const result = split
        .map((x) => {
          return x.charAt(x, 0).toLocaleUpperCase('tr');
        })
        .join('');
      setAvatarName(result);
    }
  }, [name, url]);

  if (avatarName) {
    return (
      <div className="micro-avatar-view" ref={myAvatar} style={styles}>
        <div
          className="text-view"
          style={{ fontSize: sizes.font, lineHeight: sizes.line }}
        >
          {avatarName}
        </div>
      </div>
    );
  }

  return (
    <div className="micro-avatar-view" style={styles}>
      <div className="image-view">
        <img src={url} alt="Avatar" />
      </div>
    </div>
  );
};

export default Avatar;
